/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateEmailAddressDto
 */
export interface CreateUpdateEmailAddressDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailAddressDto
     */
    emailsTo: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailAddressDto
     */
    emailsDw: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailAddressDto
     */
    emailFromId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailAddressDto
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailAddressDto
     */
    clientId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateEmailAddressDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateEmailAddressDto interface.
 */
export function instanceOfCreateUpdateEmailAddressDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "emailsTo" in value;
    isInstance = isInstance && "emailsDw" in value;
    isInstance = isInstance && "emailFromId" in value;
    isInstance = isInstance && "comment" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateEmailAddressDtoFromJSON(json: any): CreateUpdateEmailAddressDto {
    return CreateUpdateEmailAddressDtoFromJSONTyped(json, false);
}

export function CreateUpdateEmailAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEmailAddressDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailsTo': json['emailsTo'],
        'emailsDw': json['emailsDw'],
        'emailFromId': json['emailFromId'],
        'comment': json['comment'],
        'clientId': json['clientId'],
        'active': json['active'],
    };
}

export function CreateUpdateEmailAddressDtoToJSON(value?: CreateUpdateEmailAddressDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailsTo': value.emailsTo,
        'emailsDw': value.emailsDw,
        'emailFromId': value.emailFromId,
        'comment': value.comment,
        'clientId': value.clientId,
        'active': value.active,
    };
}

